import { isEmpty } from 'lodash';

import debounceActionCreators from 'helpers/redux/debounce_action_creators';
import { retrieveLeases, retrieveSales } from './search';

export const ENABLE_AUTO_BOUNDS_SEARCHING = 'ENABLE_AUTO_BOUNDS_SEARCHING';
export function enableAutoBoundsSearching() {
  return (dispatch, getState) => {
    if (!getState().coordinates.autoBoundsSearchingEnabled) {
      dispatch({ type: ENABLE_AUTO_BOUNDS_SEARCHING });
    }
  };
}

const debouncedActionCreators = debounceActionCreators({ enableAutoBoundsSearching }, 1000);
export function debouncedEnableAutoBoundsSearching() {
  return dispatch => debouncedActionCreators.enableAutoBoundsSearching(dispatch);
}

export const DISABLE_AUTO_BOUNDS_SEARCHING = 'DISABLE_AUTO_BOUNDS_SEARCHING';
export function disableAutoBoundsSearching() {
  return (dispatch, getState) => {
    if (getState().coordinates.autoBoundsSearchingEnabled) {
      dispatch({ type: DISABLE_AUTO_BOUNDS_SEARCHING });
    }
  };
}

export const SET_BOUNDS = 'SET_BOUNDS';
export function setGoogleMapsBounds(bounds) {
  return (dispatch, getState) => {
    const northEast = bounds.getNorthEast();
    const southWest = bounds.getSouthWest();

    dispatch({
      type: SET_BOUNDS,
      northEast: {
        lat: northEast.lat(),
        lng: northEast.lng()
      },
      southWest: {
        lat: southWest.lat(),
        lng: southWest.lng()
      }
    });

    const { coordinates } = getState();
    if (coordinates.autoBoundsSearchingEnabled && isEmpty(coordinates.userBounds)) {
      const { ui } = getState();
      if (ui.currentTab === 'lease') {
        dispatch(retrieveLeases());
      } else {
        dispatch(retrieveSales());
      }
    }
  };
}

export const SET_USER_BOUNDS = 'SET_USER_BOUNDS';
export function setUserBounds(bounds) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_USER_BOUNDS,
      bounds
    });

    if (getState().coordinates.autoBoundsSearchingEnabled) {
      const { ui } = getState();
      if (ui.currentTab === 'lease') {
        dispatch(retrieveLeases());
      } else {
        dispatch(retrieveSales());
      }
    }
  };
}
